import Phaser from "phaser";
import { cst } from "../helpers/cst";
import buttonBehaviours from "../helpers/button-behaviours";

export default class EndCategories extends Phaser.Scene {
  constructor() {
    super(cst.scenes.endCategories);
  }

  preload() {}

  create(data) {
    this.score = data.score;
    this.log = data.log;
    let i = 0;

    this.add.image(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
      "bg-main",
    );
    this.add.image(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2 - 75,
      "box-end",
    );

    this.totalQuestions = 0;
    this.totalCorrect = 0;

    for (let key in this.log) {
      this.totalQuestions += this.log[key].questions;
      this.totalCorrect += this.log[key].correct;

      this.add.text(
        this.cameras.main.width / 2 - 250,
        this.cameras.main.height / 2 - 200 + i * 75,
        config.categoryNames[key],
        cst.textstyles[key],
      );

      this.add
        .text(
          this.cameras.main.width / 2 + 210,
          this.cameras.main.height / 2 - 180 + i * 75,
          `${((this.log[key].correct / this.log[key].questions) * 100).toFixed(
            0,
          )}%`,
          cst.textstyles.points,
        )
        .setOrigin(0.5);
      i++;
    }

    this.add
      .text(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2 - 300,
        "Score: " + this.score,
        cst.textstyles.end,
      )
      .setOrigin(0.5);

    this.add
      .text(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2 - 375,
        `Total Correct: ${(
          (this.totalCorrect / this.totalQuestions) *
          100
        ).toFixed(0)}%`,
        cst.textstyles.end,
      )
      .setOrigin(0.5);

    this.btnMenu = this.add
      .image(
        this.cameras.main.width / 2 - 150,
        this.cameras.main.height / 2 + 405,
        "btn-menu",
      )
      .setInteractive({ useHandCursor: true })
      .on("pointerdown", () => {
        buttonBehaviours.pushOnClick(this, this.btnMenu, () => {
          this.scene.start(cst.scenes.menu);
        });
      })
      .setScale(1.5);

    this.btnPlayAgain = this.add
      .image(
        this.cameras.main.width / 2 + 150,
        this.cameras.main.height / 2 + 405,
        "btn-play-again",
      )
      .setInteractive({ useHandCursor: true })
      .on("pointerdown", () => {
        buttonBehaviours.pushOnClick(this, this.btnPlayAgain, () => {
          this.scene.start(cst.scenes.board);
        });
      })
      .setScale(1.5);
  }

  upload() {}
}
